<section class="quick-activities-page">

    <div class="page-header">
      <div>
        <h1>Lista de Actividades</h1>
        <p>
          Guarda plantillas de actividades para publicarlas nuevamente
          cuando las necesites.
        </p>
      </div>
  
      <button
        type="button"
        class="primary-button"
        (click)="openCreateForm()"
        >
        + Nueva actividad
        </button>
    </div>
  
    @if (successMessage) {
      <div class="success-message">
        {{ successMessage }}
      </div>
    }
  
    @if (showCreateForm) {
        <div class="activity-page">
      
          <div class="activity-card">
      
            <header class="activity-header">
              <span class="eyebrow">Gestión de actividades</span>
      
              <h1>Crear nueva actividad</h1>
      
              <p>
                Registra una actividad y define sus fechas, tipo, valor en horas y
                capacidad de participantes.
              </p>
            </header>
      
            <form
              [formGroup]="activityForm"
              (ngSubmit)="createActivityFromForm()"
              class="activity-form"
            >
      
              <section class="form-section">
      
                <div class="section-heading">
                  <span class="section-number">01</span>
      
                  <div>
                    <h2>Información principal</h2>
                    <p>
                      Define los datos generales de la actividad.
                    </p>
                  </div>
                </div>
      
                <div class="form-grid">
      
                  <div class="field field-full">
                    <label for="activity-title">
                      Título
                    </label>
      
                    <input
                      id="activity-title"
                      type="text"
                      formControlName="title"
                      class="form-control"
                      placeholder="Ej. Jornada de adopción"
                    />
                  </div>
      
                  <div class="field field-full">
                    <label for="activity-description">
                      Descripción
                    </label>
      
                    <textarea
                      id="activity-description"
                      formControlName="description"
                      class="form-control description-field"
                      placeholder="Describe brevemente la actividad..."
                    ></textarea>
                  </div>
      
                  <div class="field">
      
                    <label for="activity-type">
                      Tipo de actividad
                    </label>
      
                    <select
                      id="activity-type"
                      formControlName="type"
                      class="form-select"
                    >
                      <option value="" disabled>
                        Selecciona un tipo
                      </option>
      
                      @for (type of activityTypes; track type) {
                        <option [value]="type">
                          {{ type }}
                        </option>
                      }
                    </select>
      
                  </div>
      
                </div>
      
              </section>
      
      
              <section class="form-section">
      
                <div class="section-heading">
      
                  <span class="section-number">02</span>
      
                  <div>
                    <h2>Fechas, horas y cupo</h2>
      
                    <p>
                      Configura la fecha, el horario, el valor de la actividad
                      y la cantidad máxima de participantes.
                    </p>
                  </div>
      
                </div>
      
      
                <div class="form-grid">
      
                  <div class="field">
      
                    <label for="activity-start-date">
                      Fecha de inicio
                    </label>
      
                    <input
                      id="activity-start-date"
                      type="date"
                      formControlName="startDate"
                      class="form-control"
                    />
      
                  </div>
      
      
                  <div class="field">
      
                    <label for="activity-due-date">
                      Fecha límite
                    </label>
      
                    <input
                      id="activity-due-date"
                      type="date"
                      formControlName="dueDate"
                      class="form-control"
                    />
      
                  </div>
      
      
                  <div class="field">
      
                    <label for="activity-start-time">
                      Hora de inicio
                    </label>
      
                    <input
                      id="activity-start-time"
                      type="time"
                      formControlName="startTime"
                      class="form-control"
                    />
      
                  </div>
      
      
                  <div class="field">
      
                    <label for="activity-end-time">
                      Hora de finalización
                    </label>
      
                    <input
                      id="activity-end-time"
                      type="time"
                      formControlName="endTime"
                      class="form-control"
                    />
      
                  </div>
      
      
                  <div class="field">
      
                    <label for="activity-hours">
                      Valor en horas
                    </label>
      
                    <input
                      id="activity-hours"
                      type="number"
                      formControlName="valueInHours"
                      class="form-control"
                      placeholder="0"
                      min="0"
                    />
      
                  </div>
      
      
                  <div class="field field-full participant-limit-field">
      
                    <label>
                      Cupo de participantes
                    </label>
      
                    <p class="field-help">
                      Decide si la actividad tendrá un número máximo de alumnos.
                    </p>
      
      
                    <div class="participant-limit-options">
      
                      <label
                        class="participant-option"
                        [class.selected]="!hasParticipantLimit"
                      >
      
                        <input
                          type="radio"
                          name="participantLimit"
                          [checked]="!hasParticipantLimit"
                          (change)="hasParticipantLimit = false; onParticipantLimitChange()"
                        />
      
                        <span class="participant-option-content">
      
                          <strong>Sin límite</strong>
      
                          <small>
                            Cualquier cantidad de alumnos puede inscribirse.
                          </small>
      
                        </span>
      
                      </label>
      
      
                      <label
                        class="participant-option"
                        [class.selected]="hasParticipantLimit"
                      >
      
                        <input
                          type="radio"
                          name="participantLimit"
                          [checked]="hasParticipantLimit"
                          (change)="hasParticipantLimit = true; onParticipantLimitChange()"
                        />
      
                        <span class="participant-option-content">
      
                          <strong>Establecer límite</strong>
      
                          <small>
                            Define el número máximo de participantes.
                          </small>
      
                        </span>
      
                      </label>
      
                    </div>
      
      
                    @if (hasParticipantLimit) {
      
                      <div class="participant-limit-input">
      
                        <label for="activity-max-participants">
                          Número máximo de participantes
                        </label>
      
                        <div class="participant-number-wrapper">
      
                          <input
                            id="activity-max-participants"
                            type="number"
                            formControlName="maxParticipants"
                            class="form-control"
                            placeholder="Ej. 5"
                            min="1"
                            step="1"
                          />
      
                          <span>
                            participantes
                          </span>
      
                        </div>
      
      
                        @if (
                          activityForm.get('maxParticipants')?.invalid &&
                          activityForm.get('maxParticipants')?.touched
                        ) {
      
                          <small class="field-error">
                            Ingresa un número entero mayor o igual a 1.
                          </small>
      
                        }
      
                      </div>
      
                    }
      
      
                    <div class="participant-limit-summary">
      
                      @if (hasParticipantLimit) {
      
                        <span class="summary-icon">
                          👥
                        </span>
      
                        <span>
                          Esta actividad tendrá un máximo de
                          <strong>
                            {{ activityForm.get('maxParticipants')?.value || 0 }}
                            participantes
                          </strong>.
                        </span>
      
                      } @else {
      
                        <span class="summary-icon">
                          ∞
                        </span>
      
                        <span>
                          Esta actividad estará disponible
                          <strong>
                            sin límite de participantes
                          </strong>.
                        </span>
      
                      }
      
                    </div>
      
                  </div>
      
                </div>
      
              </section>
      
      
              <section class="form-section final-section">
      
                <div class="section-heading">
      
                  <span class="section-number">
                    03
                  </span>
      
                  <div>
      
                    <h2>Información adicional</h2>
      
                    <p>
                      Agrega comentarios o indicaciones para los participantes.
                    </p>
      
                  </div>
      
                </div>
      
      
                <div class="field">
      
                  <label for="activity-comments">
                    Comentarios
                  </label>
      
                  <textarea
                    id="activity-comments"
                    formControlName="comments"
                    class="form-control comments-field"
                    placeholder="Añade información adicional..."
                  ></textarea>
      
                </div>
      
              </section>
      
      
              @if (errorMessage) {
      
                <div class="form-error">
                  {{ errorMessage }}
                </div>
      
              }
      
      
              <div class="form-actions">
      
                <div>
      
                  <strong>
                    ¿Actividad lista?
                  </strong>
      
                  <span>
                    Revisa la información antes de crearla.
                  </span>
      
                </div>
      
      
                <div class="form-buttons">
      
                  <button
                    type="button"
                    class="secondary-button"
                    (click)="closeCreateForm()"
                    [disabled]="isCreatingActivity"
                  >
                    Cancelar
                  </button>
      
      
                  <button
                    type="submit"
                    class="submit-button"
                    [disabled]="!activityForm.valid || isCreatingActivity"
                    >
                    @if (isCreatingActivity) {
                        Actualizando...
                    } @else if (editingQuickActivityId) {
                        Actualizar actividad
                    } @else {
                        Crear actividad
                    }
                    </button>
      
                </div>
      
              </div>
      
            </form>
      
          </div>
      
      
          @if (showActivitySuccessMessage) {
      
            <div
              class="success-toast"
              role="status"
            >
      
              <div class="success-toast-icon">
                ✓
              </div>
      
              <div class="success-toast-content">
      
                <strong>
                  Actividad creada
                </strong>
      
                <span>
                  La actividad se creó correctamente.
                </span>
      
              </div>
      
            </div>
      
          }
      
        </div>
      }
  
    @if (isLoading) {
      <div class="state-message">
        <p>Cargando actividades rápidas...</p>
      </div>
    }
  
    @if (!isLoading && errorMessage && !showCreateForm) {
      <div class="state-message error">
        <p>{{ errorMessage }}</p>
      </div>
    }
  
    @if (!isLoading && !errorMessage && quickActivities.length === 0) {
      <div class="empty-state">
        <div class="empty-icon">⚡</div>
  
        <h2>No hay actividades rápidas</h2>
  
        <p>
          Cuando guardes una actividad como rápida,
          aparecerá aquí para poder reutilizarla.
        </p>
  
        <button
          type="button"
          class="primary-button"
          (click)="openCreateForm()"
        >
          Crear actividad rápida
        </button>
      </div>
    }
  
    @if (showPublishForm && activityToPublish) {
        <div class="create-form-card publish-form-card">
          <div class="form-header">
            <div>
              <h2>Publicar actividad</h2>
              <p>
                Configura los datos de la actividad antes de publicarla.
              </p>
            </div>
      
            <button
              type="button"
              class="close-button"
              (click)="showPublishForm = false; activityToPublish = null"
            >
              ✕
            </button>
          </div>
      
          <div class="publish-activity-summary">
            <strong>{{ activityToPublish.title }}</strong>
            <span>{{ activityToPublish.description }}</span>
          </div>
      
          <form (ngSubmit)="publishQuickActivity()">
            <div class="form-grid">
      
              <div class="form-group">
                <label for="publishStartDate">
                  Fecha de inicio *
                </label>
      
                <input
                  id="publishStartDate"
                  type="date"
                  name="publishStartDate"
                  [(ngModel)]="publishForm.startDate"
                  required
                />
              </div>
      
              <div class="form-group">
                <label for="publishDueDate">
                  Fecha de finalización *
                </label>
      
                <input
                  id="publishDueDate"
                  type="date"
                  name="publishDueDate"
                  [(ngModel)]="publishForm.dueDate"
                  required
                />
              </div>
      
              <div class="form-group">
                <label for="publishStartTime">
                  Hora de inicio
                </label>
      
                <input
                  id="publishStartTime"
                  type="time"
                  name="publishStartTime"
                  [(ngModel)]="publishForm.startTime"
                />
              </div>
      
              <div class="form-group">
                <label for="publishEndTime">
                  Hora de fin
                </label>
      
                <input
                  id="publishEndTime"
                  type="time"
                  name="publishEndTime"
                  [(ngModel)]="publishForm.endTime"
                />
              </div>
      
              <div class="form-group">
                <label for="publishMaxParticipants">
                  Cupo máximo
                </label>
      
                <input
                  id="publishMaxParticipants"
                  type="number"
                  name="publishMaxParticipants"
                  [(ngModel)]="publishForm.maxParticipants"
                  min="1"
                  placeholder="Sin límite"
                />
              </div>
      
              <div class="form-group full-width">
                <label for="publishComments">
                  Comentarios
                </label>
      
                <textarea
                  id="publishComments"
                  name="publishComments"
                  rows="3"
                  [(ngModel)]="publishForm.comments"
                  placeholder="Información adicional..."
                ></textarea>
              </div>
      
            </div>
      
            @if (errorMessage) {
              <div class="form-error">
                {{ errorMessage }}
              </div>
            }
      
            <div class="form-actions">
      
              <button
                type="button"
                class="secondary-button"
                (click)="showPublishForm = false; activityToPublish = null"
                [disabled]="isSaving"
              >
                Cancelar
              </button>
      
              <button
                type="submit"
                class="primary-button"
                [disabled]="isSaving"
              >
                @if (isSaving) {
                  Publicando...
                } @else {
                  Publicar actividad
                }
              </button>
      
            </div>
          </form>
        </div>
    }

    @if (
        !isLoading &&
        !errorMessage &&
        !showCreateForm &&
        !showPublishForm &&
        quickActivities.length > 0
        ) {
  
      <div class="quick-activities-grid">
  
        @for (activity of pagedQuickActivities; track activity.id) {
  
          <article class="quick-activity-card">
  
            <div class="card-header">
  
              <div>
                <span class="activity-badge">
                  Actividad rápida
                </span>
  
                <h2>{{ activity.title }}</h2>
              </div>
  
              <span class="hours-badge">
                {{ activity.valueInHours }} h
              </span>
  
            </div>
  
            <p class="description">
              {{ activity.description || 'Sin descripción.' }}
            </p>
  
            <div class="activity-details">
  
              <div class="detail">
                <span class="detail-label">
                  Horario
                </span>
  
                <strong>
                  {{ activity.startTime || '--:--' }}
                  -
                  {{ activity.endTime || '--:--' }}
                </strong>
              </div>
  
              <div class="detail">
                <span class="detail-label">
                  Cupo
                </span>
  
                <strong>
                  @if (activity.maxParticipants) {
                    {{ activity.maxParticipants }} personas
                  } @else {
                    Sin límite
                  }
                </strong>
              </div>
  
            </div>
  
              <div class="comments">
                <span class="comments-label">COMENTARIOS</span>

                @if (activity.comments) {
                    <span class="comments-text">
                    {{ activity.comments }}
                    </span>
                } @else {
                    <span class="comments-text no-comments">
                    Sin comentarios.
                    </span>
                }
              </div>
            
  
            <div class="card-actions">
  
                <button
                type="button"
                class="secondary-button"
                (click)="openEditForm(activity)"
              >
                Editar
              </button>
  
              <button
                type="button"
                class="primary-button"
                (click)="openPublishForm(activity)"
              >
                Publicar
              </button>
  
              <button
                    type="button"
                    class="danger-button"
                    (click)="openDeleteModal(activity)"
                    >
                    Eliminar
                </button>
  
            </div>
  
          </article>
  
        }
  
      </div>

      <app-pagination
        [(page)]="page"
        [totalItems]="quickActivities.length"
        [pageSize]="pageSize"
      ></app-pagination>
  
    }
  
</section>

@if (showDeleteModal && activityToDelete) {
    <div class="modal-backdrop">
      <div class="delete-modal">
        <div class="delete-modal-icon">
          🗑️
        </div>
  
        <h2>¿Eliminar actividad rápida?</h2>
  
        <p>
          ¿Estás seguro de que quieres eliminar
          <strong>{{ activityToDelete.title }}</strong>?
        </p>
  
        <p class="delete-warning">
          Esta acción no se puede deshacer.
        </p>
  
        <div class="modal-actions">
          <button
            type="button"
            class="secondary-button"
            (click)="closeDeleteModal()"
          >
            Cancelar
          </button>
  
          <button
            type="button"
            class="danger-button"
            (click)="deleteQuickActivity(activityToDelete)"
          >
            Eliminar
          </button>
        </div>
      </div>
    </div>
  }